import React, { FC, useState } from 'react'
import classNames from 'classnames'
import { useWindowSize } from 'the-platform'
import {
  BREAK_LARGE,
  BREAK_MOBILE,
  BREAK_TABLET
} from '../../../utils/breakpoints'
import CardGrid from '../card-grid/CardGrid'
import './ExpandableCardGrid.less'
import IconDots from '../icon/IconDots'
import IconLink from '../icon/IconLink'
import { Flex, Box, ButtonIcon } from 'front-end/src/components'
import { useClipboard } from 'use-clipboard-copy'
import { notification } from '../notifications/Notifications'
import { t } from '@lingui/macro'
import { css } from '@emotion/react'
import { LinkBox } from '../link/Link'

export const ExpandableCardGrid: FC<{
  cards: Array<React.ReactElement<any>>
  title: string
  renderShowMore: (cardsCount: number) => JSX.Element
  copyAnchorId?: string
  limit?: number
}> = ({ cards, title, renderShowMore, copyAnchorId, limit: propsLimit }) => {
  const clipboard = useClipboard()
  const [expanded, setExpanded] = useState(false)
  const { width } = useWindowSize()

  let limit = propsLimit || 5

  if (!propsLimit) {
    if (width <= BREAK_MOBILE) {
      limit = 3
    }
    if (width >= BREAK_TABLET) {
      limit = 5
    }
    if (width >= BREAK_LARGE) {
      limit = 7
    }
  }

  const remainingCards = cards.length - limit
  const showCount = expanded ? cards.length : limit

  return (
    <div
      className={classNames('ExpandableCardGrid', {
        expanded
      })}
      key={title}
    >
      <Flex
        className="ExpandableCardGrid__header"
        align="center"
        css={css`
          min-height: 38px;
          &:hover .chakra-button {
            opacity: 1;
          }
        `}
      >
        <h2>{title}</h2>{' '}
        {copyAnchorId && (
          <ButtonIcon
            opacity={0}
            aria-label={t`Copy link`}
            icon={<IconLink />}
            ml="12px"
            circular
            cursor="pointer"
            onClick={() => {
              clipboard.copy(
                `${location.href.replace(location.hash, '')}#${copyAnchorId}`
              )
              notification.info(t`Successfully copied to clipboard`)
            }}
          />
        )}
      </Flex>
      <CardGrid cards={cards.slice(0, showCount)}>
        {remainingCards > 0 && !expanded && (
          <LinkBox
            className="Card ResourceCard ExpandableCardGrid__more"
            onClick={() => setExpanded(!expanded)}
          >
            <Box
              alignItems="center"
              className="ExpandableCardGrid__more__circle"
            >
              <IconDots boxSize="28px" opacity=".5" mb="16px" />
              {renderShowMore && renderShowMore(remainingCards)}
            </Box>
          </LinkBox>
        )}
      </CardGrid>
    </div>
  )
}
